import { PERMISSIONS } from '@/generated/permissions'

export const contractorRoutes = [
  {
    component: () => import('@/domains/contractors/pages/IndexPage.vue'),
    meta: {
      anyPerm: [
        PERMISSIONS.CONTRACTOR_READ,
        PERMISSIONS.CONTRACTOR_CREATE,
        PERMISSIONS.CONTRACTOR_UPDATE,
        PERMISSIONS.CONTRACTOR_DELETE,
      ],
      requiresAuth: true,
    },
    name: 'contractors-index',
    path: '/contractors',
  },
  {
    component: () => import('@/domains/contractors/pages/NewPage.vue'),
    meta: { anyPerm: [PERMISSIONS.CONTRACTOR_CREATE], requiresAuth: true },
    name: 'contractors-new',
    path: '/contractors/new',
  },
  {
    component: () => import('@/domains/contractors/pages/DetailPage.vue'),
    meta: { anyPerm: [PERMISSIONS.CONTRACTOR_UPDATE], requiresAuth: true },
    name: 'contractors-detail',
    path: '/contractors/:id',
  },
  {
    component: () => import('@/domains/contractors/pages/KioskPage.vue'),
    meta: { layout: false, requiresAuth: false },
    name: 'contractor-time-sheet',
    path: '/contractor-time-sheet',
  },
]
